import { type Ref, ref, computed } from "vue";
import apiSkobo from "@/helpers/api/apiSkobo";

interface SensitivityLabel {
  label: string;
  [key: string]: unknown;
}

export const useSensitivityLabelsComposable = () => {
  const sensitivityLabelsState: Ref<Record<string, SensitivityLabel>> = ref({});

  const sensitivityLabels = computed(() => sensitivityLabelsState.value);

  const setupSensitivityLabels = (incomingLabels: Array<{ key: string; value: string }>) => {
    incomingLabels.forEach(label => {
      const parsedLabel = JSON.parse(label.value);
      sensitivityLabelsState.value[label.key] = parsedLabel;
    });
  };

  const createSensitivityLabel = async (sensitivityLabel: SensitivityLabel) => {
    const sensitivityLabelDto = {
      key: sensitivityLabel.label.toLowerCase(),
      value: JSON.stringify(sensitivityLabel)
    };

    await apiSkobo
      .post("/me/setup/sensitivityLabel", sensitivityLabelDto)
      .then(() => {
        const labels = { ...sensitivityLabelsState.value };
        labels[sensitivityLabel.label.toLowerCase()] = sensitivityLabel;
        sensitivityLabelsState.value = labels;
      })
      .catch(() => {});
  };

  const deleteSensitivityLabel = async (sensitivityLabel: SensitivityLabel) => {
    await apiSkobo
      .delete(`/me/setup/SensitivityLabel/${sensitivityLabel.label.toLowerCase()}`)
      .then(() => {
        const labels = { ...sensitivityLabelsState.value };
        delete labels[sensitivityLabel.label.toLowerCase()];
        sensitivityLabelsState.value = labels;
      })
      .catch(() => {});
  };

  return {
    sensitivityLabelsState,
    sensitivityLabels,
    setupSensitivityLabels,
    createSensitivityLabel,
    deleteSensitivityLabel
  };
};
